import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { getRebuildAPI } from "@rebuild/shared/api";
import type { UpdateEstimateMitigationDetailsBody } from "@rebuild/shared/generated/models/updateEstimateMitigationDetailsBody";
import { ESTIMATE_KEYS } from "@/hooks/queries/estimates/queryKeys";

const { estimatesControllerUpdateEstimateMitigationDetails } = getRebuildAPI();

export function useUpdateMitigationDetailsMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: UpdateEstimateMitigationDetailsBody) => {
      // customInstance throws on a non-2xx response, so a resolved call means the write succeeded. Returns
      // the response body ({ success, lineItemSyncQueued }) so callers can gate the line-item resync UI on it.
      return estimatesControllerUpdateEstimateMitigationDetails(body);
    },
    onError: (error) => {
      toast.error("Failed to update mitigation details");
      console.error("Update mitigation details error:", error);
    },
    onSuccess: (data, variables) => {
      if (!data.lineItemSyncQueued) {
        queryClient.invalidateQueries({
          queryKey: ESTIMATE_KEYS.detailMetadata(variables.estimateId),
        });
      }
    },
  });
}
